import { render, staticRenderFns } from "./VotingPage.vue?vue&type=template&id=2f2b9aac"
import script from "./VotingPage.vue?vue&type=script&lang=js"
export * from "./VotingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports